import { useDispatch, useSelector } from "react-redux";
import {
  addToHistory,
  clearHistory,
  handleNavigationState,
  navigateToPreviousScreen,
  updateProductIdAtIndex,
} from "@redux/slices/navigationHistorySlice";

export const useNavigationHistory = () => {
  const dispatch = useDispatch();
  const currentIndex = useSelector(
    (state: any) => state.navigationHistory.currentIndex
  );
  const addRouteToHistory = (route: any) => {
    if (route?.name) {
      dispatch(
        addToHistory({
          screen: route.name,
          params: route.params,
        })
      );
    }
  };

  const clearRouteHistory = () => {
    dispatch(clearHistory());
  };

  const navigateBack = () => {
    dispatch(navigateToPreviousScreen());
  };

  const handleBuilderNavigationState = (screen: any, params: any) => {
    const route = {
      name: screen,
      params: params,
    };
    dispatch(
      handleNavigationState({
        screen: route.name,
        params: route.params,
      })
    );
  };

  const replaceProductIdInHistory = (productID: number) => {
    dispatch(updateProductIdAtIndex({ index: currentIndex, productID }));
  };

  return {
    addRouteToHistory,
    clearRouteHistory,
    navigateBack,
    handleBuilderNavigationState,
    replaceProductIdInHistory,
  };
};
